import { mixpanelService, useNetworkState } from '@register-ui/utils';
import { CustomerMetricsContext } from '@moniebook-web/utils';
import { useLiveQuery } from 'dexie-react-hooks';
import { useCallback, useContext, useEffect } from 'react';

export function CustomerMetricsOfflineSync() {
    const { pushData } = useContext(CustomerMetricsContext);

    const events = useLiveQuery(() => mixpanelService.getAll(), []);
    const { isOnline } = useNetworkState();

    const sendOfflineEvents = useCallback(async () => {
        if (!events?.length) return;

        await pushData?.(...events);

        await mixpanelService.removeAll();
    }, [events, pushData]);

    useEffect(() => {
        if (!isOnline || !events?.length) return;

        sendOfflineEvents();
    }, [isOnline, events?.length, sendOfflineEvents]);

    return null;
}
